import { render } from "./MenuPage.vue?vue&type=template&id=364f5306"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"
script.render = render

export default script